'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../Common/Managers/ProcessManager';
//Helper html
import HtmlMapper from "../../Common/Helpers/HtmlMapper";
/**
 * Importación de las Actions.
 */
import {
    GET_DATA_INSTANCIA_PARAMETROS,
    AGREGAR_EQUIVALENCIA,
    ELIMINAR_EQUIVALENCIA,
    LIMPIAR_ESTADO_NUEVA_INSTANCIA,
    ACTUALIZAR_EQUIVALENCIA,
    ACTUALIZAR_INSTANCIA,
    GUARDAR_INSTANCIA_PARAMETRO,
    VALIDAR_INSTANCIA_PARAMETRO,
    MOSTRAR_SPINNER_GUARDADO,
    FINALIZAR_GUARDADO,
    CAMBIAR_ACTIVO_INSTANCIA_PARAMETRO,
    ERROR_MODAL_POST_VALIDADOR,
    SET_ES_ALTA_INSTANCIA,
    ACTUALIZAR_SUBEQUIVALENCIA
} from '../../Screens/NuevaInstanciaParametro/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        nombreEntidad: "",
        codigoEntidad: "",
        generoEntidad: "",
        requiereEquivalencia: "",
        instancias: [],
        equivalencias: undefined,
        instanciaEquivalencias: undefined,
        dataRecuperada: false,
        seEstaGuardando: false,
        idEquivalenciaInstancia: 0,
        seModifico: false,
        huboError: false,
        mostrarModal: false,
        rutearVistaInstancia: false,
        rutaVistaInstancia: "",
        instanciaPropiedades: undefined,
        postValidador: undefined,
        mostrarModalPostValidador: false,
        mensajePostValidador: undefined,
        esAltaInstancia: undefined
    },
    saga: {
        sagaId: undefined,
        mensaje: undefined,
        seCompletoSaga: false
    }
}
/**
 * 
 * @param {any} state
 * @param {any} action
 */
function nuevaInstanciaParametro(state = initialState, action) {
    LogHelper.In(nuevaInstanciaParametro.name, state, action);

    switch (action.type) {
        case GET_DATA_INSTANCIA_PARAMETROS: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            const { instanciaEquivalencias, equivalencias, generoEntidad, instanciaPropiedades,
                requiereEquivalencia, nombreEntidad, codigoEntidad, instancias, postValidador, requiereSubequivalencia, subEquivalencias } = action.dataInstanciaParametro;


            instanciaEquivalencias.forEach((ins) => {
                let eqEncontrada = equivalencias.find((eq) => eq.Id == ins.IdEquivalencia);

                if (eqEncontrada) {
                    eqEncontrada.IdEquivalenciaInstancia = ins.IdEquivalenciaInstancia;
                }
            });

            sessionStorage.setItem('PantallaCambios', false);

            return {
                ...state,
                data: {
                    ...state.data,
                    nombreEntidad,
                    codigoEntidad,
                    generoEntidad,
                    requiereEquivalencia,
                    instancias,
                    equivalencias,
                    instanciaEquivalencias,
                    dataRecuperada: true,
                    instanciaPropiedades,
                    postValidador,
                    requiereSubequivalencia,
                    subEquivalencias
                }
            }
        }
        case AGREGAR_EQUIVALENCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            let indiceNuevo = state.data.idEquivalenciaInstancia - 1;
            let requiereSubequivalencia = state.data.requiereSubequivalencia;
            let valorPorDefecto = state.data.subEquivalencias.filter( x => x.Codigo.toUpperCase() == "Por defecto".toUpperCase())[0];

            let nuevaEquivalencia = requiereSubequivalencia ? 
                {
                    IdEquivalencia: 0,
                    IdEquivalenciaInstancia: indiceNuevo,
                    ValorEquivalencia: "",
                    DeleteInstance: false,
                    SubequivalenciaId: valorPorDefecto.Id,
                    CodigoSubequivalencia: valorPorDefecto.Codigo
                } 
            :
                {
                    IdEquivalencia: 0,
                    IdEquivalenciaInstancia: indiceNuevo,
                    ValorEquivalencia: "",
                    DeleteInstance: false
                };

            state.data.instanciaEquivalencias.push(nuevaEquivalencia);
            sessionStorage.setItem('PantallaCambios', true);

            return {
                ...state,
                data: {
                    ...state.data,
                    idEquivalenciaInstancia: indiceNuevo
                }
            }
        }
        case CAMBIAR_ACTIVO_INSTANCIA_PARAMETRO: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);
            sessionStorage.setItem('PantallaCambios', true);


            return {
                ...state,
                data: {
                    ...state.data,
                    instancias: action.instancias
                }
            }
        }
        case ELIMINAR_EQUIVALENCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            const { data } = state;
            const idEquivalenciaAnterior = data.instanciaEquivalencias.find(ie => ie.IdEquivalenciaInstancia == action.id).IdEquivalencia;

            const resultado = data.instanciaEquivalencias.find((ie, index) => {
                ie.index = index;

                let existe = ie.IdEquivalenciaInstancia == action.id;

                if (existe) {
                    /*Cuando viene desde la base*/
                    if (ie.IdEquivalenciaInstancia > 0) {
                        ie.DeleteInstance = true;
                    } else {
                        /*Si no esta en la base*/
                        ie.DeleteInstance = false;
                    }
                }

                return existe;
            });

            //Limpio los mensajes de validación correspondiente a las instancias que tenían el mismo IdEquivalencia de la instancia eliminada
            data.instanciaEquivalencias.forEach((ie) => {
                if(idEquivalenciaAnterior == ie.IdEquivalencia) {
                    ie.errorCodigoRepetido = false;
                    ie.errorSubequivalenciaRepetida = false;
                }
            });

            data.equivalencias.forEach((eq) => {
                if (eq.Id == resultado.IdEquivalencia) {
                    delete eq.IdEquivalenciaInstancia;
                }
            });

            /*Saco del array los que no son de la base*/
            if (resultado.DeleteInstance == false) {
                data.instanciaEquivalencias.splice(resultado.index, 1);
            }

            sessionStorage.setItem('PantallaCambios', true);


            return state
        }
        case ACTUALIZAR_EQUIVALENCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            const { idEquivalenciaInstancia, idEquivalencia, valorEquivalencia } = action;

            let valorPorDefecto = state.data.subEquivalencias.filter( x => x.Codigo.toUpperCase() == "Por defecto".toUpperCase())[0];

            const idEquivalenciaAnterior = state.data.instanciaEquivalencias.find(ie => ie.IdEquivalenciaInstancia == idEquivalenciaInstancia).IdEquivalencia;

            state.data.seModifico = true;
            state.data.instanciaEquivalencias.forEach((ie) => {
                if (ie.IdEquivalenciaInstancia == idEquivalenciaInstancia) {
                    //Si se modifico la equivalencia, es decir el usuario selecciono una
                    if (idEquivalencia) {
                        ie.IdEquivalencia = idEquivalencia;
                        //Se reinicia el valor de Id de Subequivalencia para no acomplejizar la lógica de visualización de valores del combo de subequivalencia
                        ie.SubequivalenciaId = valorPorDefecto.Id;
                        ie.CodigoSubequivalencia = valorPorDefecto.Codigo;
                        ie.errorCodigoRepetido = false;
                        ie.errorSubequivalenciaRepetida = false;
                    }

                    if (valorEquivalencia || valorEquivalencia == "") {
                        ie.ValorEquivalencia = valorEquivalencia;
                        ie.errorCodigoRepetido = false;
                        ie.errorSubequivalenciaRepetida = false;
                    }
                   // Eliminar error específico para esta instancia
                   ie.huboError = false;
                } else {
                    if (idEquivalenciaAnterior == ie.IdEquivalencia) {
                        // Restablecer errores para otras instancias
                        ie.errorSubequivalenciaRepetida = false;
                        ie.errorCodigoRepetido = false;
                        ie.huboError = false;                       
                    }
                }
            });

            sessionStorage.setItem('PantallaCambios', true);


            return _validarEquivalencias(state);
        }

        case ACTUALIZAR_SUBEQUIVALENCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            const { idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia } = action;
            const idEquivalencia = state.data.instanciaEquivalencias.find(ie => ie.IdEquivalenciaInstancia == idEquivalenciaInstancia).IdEquivalencia;

            state.data.seModifico = true;
            
            state.data.instanciaEquivalencias.forEach((ie) => {
                if (ie.IdEquivalenciaInstancia == idEquivalenciaInstancia) {
                    //Si se modifico la equivalencia, es decir el usuario selecciono una
                    if (idSubEquivalencia) {
                        ie.SubequivalenciaId = idSubEquivalencia;
                        ie.CodigoSubequivalencia = codigoSubequivalencia;
                        ie.errorSubequivalenciaRepetida = false;
                    }

                    // Eliminar error específico para esta instancia
                    ie.huboError = false;
                } else {
                    if (idEquivalencia == ie.IdEquivalencia) {
                        // Restablecer errores para otras instancias
                        ie.errorSubequivalenciaRepetida = false;
                        ie.huboError = false;                  
                    }
                }
            });

            sessionStorage.setItem('PantallaCambios', true);

            let despliegueLabelHuboError = _ValidacionGeneralEquivalencias(state.data.instancias, state.data.instanciaEquivalencias, state);

            state.data.huboError = despliegueLabelHuboError;

            return state;
        }

        case ACTUALIZAR_INSTANCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);
            state.data.instancias.forEach((ins) => {
                if (ins.Codigo == action.codigo) {
                    ins = _validarInstanciaOnChange(ins, action.valor).instancia;
                }
            });

            sessionStorage.setItem('PantallaCambios', true);

            let despliegueLabelHuboError = _ValidacionGeneralEquivalencias(state.data.instancias, state.data.instanciaEquivalencias,state);

            return {
                ...state,
                data: {
                    ...state.data,
                    huboError: despliegueLabelHuboError,
                    seModifico: true
                }
            }
        }
        case LIMPIAR_ESTADO_NUEVA_INSTANCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            return initialState;
        }
        case GUARDAR_INSTANCIA_PARAMETRO: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            let mensaje;
            //ESTADO Descripcion
            //1	     Iniciada
            //2	     Completada
            //3	     Error
            //4	     CompletadaConDependencias
            //5	     CompletadaErrores
            //6	     Abortada
            //7	     EnCancelacion
            let seCompletoSaga = false;
            switch (action.estadoId) {
                case 2: {
                    mensaje = action.esEdicion ? "El registro se ha modificado exitosamente." : "El registro se ha creado exitosamente.";
                    seCompletoSaga = true;
                    break;
                }
                case 3:
                case 5: {
                    mensaje = `Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " ${action.sagaId}`;
                    break;
                }
                case 4:
                    mensaje = "Disculpe, hay datos en la transacción que dependen de procesos que todavían no fueron finalizados, "
                        + "por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los "
                        + "que dependen esta transacción hayan finalizado correctamente será avisado y la transacción avanzará "
                        + "automáticamente por su circuito normal.";
                    break;
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    mostrarModal: true,
                    seEstaGuardando: false,
                    seModifico: false
                },
                saga: {
                    sagaId: action.sagaId,
                    mensaje,
                    seCompletoSaga
                }
            };
        }
        case VALIDAR_INSTANCIA_PARAMETRO: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);        
            return {
                ...state,
                data: {
                    ...state.data,
                    huboError: action.huboError,
                    seEstaGuardando: action.seEstaGuardando
                }
            }
        }
        case MOSTRAR_SPINNER_GUARDADO: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            return {
                ...state,
                data: {
                    ...state.data,
                    seEstaGuardando: true
                }
            }
        }
        case FINALIZAR_GUARDADO: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            let rutaVistaInstancia = ProcessManager.GetNextStep("NuevaInstanciaParametro", "ROUTE_TO_VISTA_INSTANCIA_PARAMETRO");

            return {
                ...state,
                data: {
                    ...state.data,
                    mostrarModal: false,
                    rutearVistaInstancia: (state.saga.seCompletoSaga == true),
                    rutaVistaInstancia
                }
            }
        }

        case ERROR_MODAL_POST_VALIDADOR: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            return {
                ...state,
                data: {
                    ...state.data,
                    mostrarModalPostValidador: action.mostrarModal,
                    mensajePostValidador: action.mensaje
                }
            }
        }

        case SET_ES_ALTA_INSTANCIA: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            return {
                ...state,
                data: {
                    ...state.data,
                    esAltaInstancia: action.esAltaInstancia
                }
            }
        }
        
        default: {
            LogHelper.In(nuevaInstanciaParametro.name, state, action);

            return state
        }
    }
}

function validarValoresUnCaracter(ins){
    let codigosUnCaracter = ["EMPRESAINDIVIDUOS","TIPOLIMITE","MONEDALIMITECOMPRA","ALCANCE","TIPOPLASTICO",
                              "TIPOPERSONA","INDIVIDUOSEMPRESA","TIPOPERSONA"];
    let rst = false;
    codigosUnCaracter.map((cod) =>{
                            if(cod == ins.Codigo)
                                rst = true;
                        });
    return rst;
}

/**
 * 
 * @param {any} state
 */
function _validarInstanciaOnChange(instancia, valor) {
    LogHelper.In(_validarInstanciaOnChange.name, instancia, valor);

    const tipoElemento = HtmlMapper.ObtenerTipoElemento(instancia.TipoCodigo);
    let validacion = { campoCompleto: true, formatoCorrecto: true, mensaje: "" }
    delete instancia.mensajeError;
    instancia.Valor = valor;

    /*se agrega validacion para excluir aquellos campos que no son necesarios*/
    if ((!(instancia.Obligatorio && instancia.EstaVisible)) && (instancia.Regexp == '')) {
        return {
            instancia,
            validacion
        }
    }

    /*Si el tipo de elemento es un input text entonces valido:*/
    if (tipoElemento.esInputText) {
        /*Valido que el campo tenga mas de 0 length*/
        if (valor.length == 0 && instancia.Obligatorio) {
            validacion.campoCompleto = false;
            validacion.mensaje = `Por favor, debe completar el campo ${instancia.Descripcion}`;
        }
        /*Valido la expresion regular si es que tiene*/
        if (validacion.campoCompleto) {
            if(validarValoresUnCaracter(instancia))
                valor = valor.toString().toUpperCase()
                
            if (instancia.Regexp && instancia.Regexp != "") {
                validacion.formatoCorrecto = new RegExp(instancia.Regexp).test(valor);

                if (!validacion.formatoCorrecto && valor.length != 0) {
                    /*Seteo el valor del mensaje en caso de que el formato no sea el correcto*/
                    validacion.mensaje = `El campo ${instancia.Descripcion} no posee un formato correcto`;
                }
            }
        }
    }
    /*Si el tipo de elemento es un select, valido que no sea igual a 0*/
    /*Se modifica el valor del "Seleccione..." a "-1" para integrar el valor "Todos/as" al combo - AD17-1349 */
    if (tipoElemento.esSelect) {
        if (valor == -1 && instancia.Obligatorio) {
            validacion.campoCompleto = false;
            validacion.mensaje = "Por favor, debe seleccionar una opción";
        }
    }

    instancia.esValido = !(validacion.campoCompleto == false || validacion.formatoCorrecto == false);
    instancia.mensajeError = validacion.mensaje;


    LogHelper.Out(_validarInstanciaOnChange.name, instancia, validacion);
    return {
        instancia,
        validacion
    }
}

/**
 * 
 * @param {any} state
 */
function _validarEquivalencias(state) {
    LogHelper.In(_validarEquivalencias.name, state);

    state.data.instanciaEquivalencias.forEach((ins) => {
        if (ins.IdEquivalencia == 0 || ins.ValorEquivalencia == "" || !ins.ValorEquivalencia) {
            ins.huboError = true;
        } else {
            delete ins.huboError;
        }
    });

    LogHelper.Out(_validarEquivalencias.name, state);

    let despliegueLabelHuboError = _ValidacionGeneralEquivalencias(state.data.instancias, state.data.instanciaEquivalencias, state);

    state.data.huboError = despliegueLabelHuboError;

    return state;
}
function _ValidacionGeneralEquivalencias(instancias, instanciaEquivalencias, state) {
    // Verificar si hay instancias inválidas
    const instanciaInvalida = instancias.some(instancia => instancia.hasOwnProperty('esValido') && !instancia.esValido);

    // Verificar instanciaEquivalencias
    const hayErrorEquivalencias = instanciaEquivalencias.some(ins => {
        if (ins.errorSubequivalenciaRepetida === true) {
            // Verificar si el valor de la instancia es mayor que 0
            if (instancias.some(instancia => instancia.Valor > 0)) {                
                state.data.huboError = true;
            } else {
                state.data.huboError = false;
            }
            return true;
        }
        return false;
    });

   
    // Devolver true si se encuentra una instancia inválida o hay error en las instanciaEquivalencias
    return !!instanciaInvalida || hayErrorEquivalencias;
}


export default nuevaInstanciaParametro;